/// <amd-module name="SuiteCommerce.ItemRecSys.WidgetCctView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define("SuiteCommerce.ItemRecSys.WidgetCctView", ["require", "exports", "underscore", "CustomContentType.Base.View", "Backbone.CollectionView", "Utils", "SuiteCommerce.ItemRecSys.WidgetCct.ItemView", "ns_recsys_widget_cct.tpl", "jQuery", "SC.Configuration", "SuiteCommerce.ItemRecSys.WidgetCct.WidgetModel", "SuiteCommerce.ItemRecSys.LogParameters", "SuiteCommerce.ItemRecSys.Instrumentation.Logger", "SuiteCommerce.ItemRecSys.InViewportObserver", "SuiteCommerce.ItemRecSys.Common.Helper"], function (require, exports, _, CustomContentTypeBaseView, BackboneCollectionView, Utils, ItemView_1, widget_tpl, jQuery, Configuration, WidgetModel_1, LogParameters_1, Logger_1, InViewportObserver_1, Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetCctView = void 0;
    var VIEW_RENDER_THROTTLE_TIMEOUT = 100;
    var IN_VIEWPORT_PERCENT_THRESHOLD = 75;
    var WidgetCctView = /** @class */ (function (_super) {
        __extends(WidgetCctView, _super);
        function WidgetCctView(options) {
            var _this = _super.call(this, options) || this;
            _this.options = options;
            _this.template = widget_tpl;
            _this.events = {};
            _this.slider = null; // todo add typins if interested
            _this.cctSettings = null;
            _this.renderTimeout = null;
            _this.inViewportObserver = null;
            _this.widgetShownLogged = false;
            _this.$el.attr('id', options.instanceId);
            _this.options = options;
            _this.model = new WidgetModel_1.WidgetModel(options);
            _this.setModelChangeListener();
            return _this;
        }
        /**
         * Idempotent model change listener hooking
         * (this needs to be called multiple times as CCT Views have a "very special" life-cycle)
         */
        WidgetCctView.prototype.setModelChangeListener = function () {
            this.stopListening(this.model);
            this.listenTo(this.model, 'change', this.onModelChange);
        };
        WidgetCctView.prototype.install = function (settings, contextData) {
            this.cctSettings = settings;
            _super.prototype.install.call(this, settings, contextData);
            return jQuery.Deferred().resolve();
        };
        WidgetCctView.prototype.update = function (settings) {
            this.cctSettings = settings;
            _super.prototype.update.call(this, settings);
            return jQuery.Deferred().resolve(true);
        };
        WidgetCctView.prototype.onModelChange = function () {
            this.scheduleRender();
            this.widgetShownLogged = false;
        };
        /**
         * this is the only entry point from CMS on navigation
         * when navigating between the items the life-cycle callbacks are basically destroy->render->destroy...
         * base.destroy (_destroy) unhooks listener so we've gotta reset them
         */
        WidgetCctView.prototype.render = function () {
            this.setModelChangeListener();
            this.model.update(this.cctSettings);
            this.scheduleRender();
            return this;
        };
        /**
         * Throttles incoming render "requests"
         */
        WidgetCctView.prototype.scheduleRender = function () {
            clearTimeout(this.renderTimeout);
            this.renderTimeout = setTimeout(this.doRender.bind(this), VIEW_RENDER_THROTTLE_TIMEOUT);
        };
        WidgetCctView.prototype.doRender = function () {
            if (this.model.hasItems() || (0, Helper_1.isCmsAdmin)()) {
                this._render();
                this.initSlider();
                this.initInViewportObserverLogging();
            }
        };
        WidgetCctView.prototype.initSlider = function () {
            var _this = this;
            var $carousel = this.$el.find('[data-type="carousel-items"]');
            if ($carousel.length < 1) {
                return;
            }
            this.destroySlider();
            var bxSliderConf = Configuration.get('bxSliderDefaults');
            // image height fix
            if (Utils.isPhoneDevice() === false) {
                var slideWidthOverride = Configuration.get("intelligentrecommendations.slideWidth", 0);
                if (slideWidthOverride)
                    bxSliderConf['slideWidth'] = slideWidthOverride;
                var thumbHeight_1 = 0;
                var slideHeightOverride = Configuration.get("intelligentrecommendations.slideHeight", 0);
                if (slideHeightOverride)
                    thumbHeight_1 = slideHeightOverride;
                else if (Configuration.get('siteSettings.imagesizes', false)) {
                    thumbHeight_1 = _.where(Configuration.get('siteSettings.imagesizes', []), { name: Configuration.get('imageSizeMapping.thumbnail', '') })[0].maxheight;
                }
                else {
                    $('.facets-item-cell-grid-image-wrapper').find('img').each(function () {
                        var height = $(this).height();
                        if (height > thumbHeight_1) {
                            thumbHeight_1 = height;
                        }
                    });
                }
                // fix height if thumbnail is bigger than max slide width
                if (bxSliderConf['slideWidth'] && bxSliderConf['slideWidth'] < thumbHeight_1) {
                    thumbHeight_1 = bxSliderConf['slideWidth'];
                }
                if (thumbHeight_1) {
                    $carousel.find('.facets-item-cell-grid-image-wrapper').css('height', thumbHeight_1);
                    $carousel.find('.facets-item-cell-grid-image-wrapper img')
                        .css({ position: 'relative', top: '50%', transform: 'translateY(-50%)' });
                }
            }
            if ($carousel.bxSlider && !Utils.oldIE() && !SC.isPageGenerator()) {
                var options_1 = __assign(__assign({}, bxSliderConf), { onSlideBefore: this.logSliderSlide.bind(this), maxSlides: Configuration.get("intelligentrecommendations.maxSlides", 8), minSlides: Configuration.get("intelligentrecommendations.minSlides", 1), touchEnabled: Utils.isPhoneDevice() });
                // this fixes viewport resizing issues
                setTimeout(function () {
                    _this.slider = $carousel.bxSlider(options_1);
                    // unify title heights
                    var $titles = jQuery('.item-recsys-widget-container .facets-item-cell-grid-title');
                    var titlesArray = $titles.toArray();
                    if (titlesArray.length > 0) {
                        var titleMaxHeight = titlesArray.map(function (el) { return jQuery(el).height(); }).reduce(function (a, b) { return Math.max(a, b); });
                        if (titleMaxHeight) {
                            $titles.height(titleMaxHeight);
                        }
                    }
                });
            }
        };
        WidgetCctView.prototype.initInViewportObserverLogging = function () {
            if (this.widgetShownLogged) {
                return;
            }
            try {
                if (this.inViewportObserver) {
                    this.inViewportObserver.destroy();
                }
                this.inViewportObserver = new InViewportObserver_1.InViewportObserver(this, IN_VIEWPORT_PERCENT_THRESHOLD, this.logWidgetShown.bind(this));
            }
            catch (_a) {
                this.logWidgetShown(); // fallback - if observer fails to initialize, log widgetShown
            }
        };
        WidgetCctView.prototype.logSliderSlide = function () {
            if ((0, Helper_1.isCmsAdmin)()) {
                return;
            }
            Logger_1.Logger.get().info(__assign(__assign({}, this.model.recSysLogData), { subType: LogParameters_1.EventType.WIDGET_CAROUSELLED }));
        };
        WidgetCctView.prototype.logWidgetShown = function () {
            if (this.widgetShownLogged || !this.model.hasItems() || (0, Helper_1.isCmsAdmin)()) {
                return;
            }
            Logger_1.Logger.get().info(__assign(__assign({}, this.model.recSysLogData), { subType: LogParameters_1.EventType.WIDGET_SHOWN, shownItems: JSON.stringify(this.model.itemCollection.pluck('_id')) }));
            this.widgetShownLogged = true;
        };
        WidgetCctView.prototype.logItemClicked = function (itemId) {
            if (!itemId || (0, Helper_1.isCmsAdmin)()) {
                return;
            }
            Logger_1.Logger.get().info(__assign(__assign({}, this.model.recSysLogData), { clickedItemId: Number(itemId), subType: LogParameters_1.EventType.WIDGET_CLICKED }));
        };
        WidgetCctView.prototype.destroy = function () {
            this.destroySlider();
            if (this.inViewportObserver) {
                this.inViewportObserver.destroy();
            }
            return _super.prototype.destroy.call(this);
        };
        WidgetCctView.prototype.destroySlider = function () {
            if (this.slider) {
                this.slider.destroySlider();
                this.slider = null;
            }
        };
        Object.defineProperty(WidgetCctView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'SuiteCommerce.ItemRecSys.WidgetCct.View': function () {
                        return new BackboneCollectionView({
                            childView: ItemView_1.ItemView,
                            collection: _this.model.itemCollection,
                            childViewOptions: {
                                container: _this.options.container,
                                clickEventHandler: _this.logItemClicked.bind(_this),
                            },
                            options: _this.options,
                        });
                    }
                };
            },
            enumerable: false,
            configurable: true
        });
        WidgetCctView.prototype.getContext = function () {
            return {
                shouldShow: this.model.hasItems() || (0, Helper_1.isCmsAdmin)(),
                hasHeader: !!this.model.getHeader(),
                headerText: this.model.getHeader(),
                showAdminMessageOverlay: (0, Helper_1.isCmsAdmin)() && this.model.cmsAdminMessages.length > 0,
                adminMessages: this.model.cmsAdminMessages
            };
        };
        return WidgetCctView;
    }(CustomContentTypeBaseView));
    exports.WidgetCctView = WidgetCctView;
});
